import React from 'react';
import { MicrophoneIcon as HeroMicrophoneIcon } from '@heroicons/react/solid';
import { Icon, IconProps } from '../Icon';

type MicrophoneIconProps = Omit<IconProps, 'children'>;

export const MicrophoneIcon: React.FC<MicrophoneIconProps> = (props) => {
    return (
        <Icon {...props}>
            <HeroMicrophoneIcon />
        </Icon>
    );
};
